export default __webpack_public_path__ + "static/media/loop-gif.affecab3.gif";